<template>
    <div class="customer__form modal modal--default">
        <div class="modal__panel modal__panel--service">
            <!-- <div class="modal__logo-wrapper">
            <div class="modal__logo"></div>
               <div class="modal__logo-title">Seguro Desk</div>  
        </div> -->

            <div class="modal__main-icon modal__main-icon--policy"></div>
            <div class="modal__back" @click="goBack()"></div>
            <div class="modal__close" @click="closeModal()"></div>

            <div class="form">
                <div class="navigators">
                    <div class="navigator navigator--active">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">
                            {{ $t(`addPolicyModal.${"title"}`) }}
                        </div>
                    </div>
                </div>

                <form v-if="teamId == null" class="add__form add__form--service">
                    <transition name="fade" mode="out-in">
                        <Loading v-if="isModalLoading" />
                        <div v-else class="add__content">
                            <div class="policy">
                                <div class="policy__form">
                                    <div class="policy__inputs">
                                        <div class="policy__column">
                                            <div class="form__field">
                                                <VSelect class="select select--default" placeholder="Teams"
                                                    :class="{ 'select--error': teamIdHasError }" :options="fetchedTeams"
                                                    :reduce="(team) => team.id" :getOptionLabel="(team) => `${team.name}`
                                                        " v-model="teamId" @input="fetchPolicyData(teamId)" />
                                                <div class="form__error" v-if="teamIdHasError">
                                                    Please select a team.
                                                </div>
                                            </div>

                                            <div class="form__field disabled-el">
                                                <VSelect disabled class="select select--default" placeholder="Agents" />
                                            </div>
                                            <div class="form__field disabled-el">
                                                <VSelect disabled class="select select--default" placeholder="Firma" />

                                            </div>
                                            <div class="form__field disabled-el">
                                                <input disabled type="text" class="input input--default"
                                                    placeholder="Policy Nr." />
                                            </div>

                                        </div>
                                        <div class="policy__column">
                                            <div class="form__field disabled-el">
                                                <VSelect disabled class="select select--default"
                                                    placeholder="Berater" />
                                            </div>
                                            <div class="form__field disabled-el">
                                                <div class="mandat">
                                                    <label class="mandat__title" for="mandatCheckbox">Makler
                                                        Mandat</label>
                                                    <div class="checkbox">
                                                        <input disabled type="checkbox" id="mandatCheckbox"
                                                            class="checkbox__checkbox" />
                                                        <label for="mandatCheckbox" class="checkbox__label"></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form__field disabled-el">
                                                <VSelect disabled class="select select--default"
                                                    placeholder="Broker Firma" />
                                            </div>
                                            <div class="form__field disabled-el">
                                                <VSelect disabled class="select select--default" placeholder="Status" />
                                            </div>
                                        </div>
                                    </div>

                                    <DropFile class="disabled-el" :disabled="true" @input="files = $event" />
                                </div>
                            </div>
                        </div>
                    </transition>
                </form>

                <form v-else class="add__form add__form--service">
                    <transition name="fade" mode="out-in">
                        <Loading v-if="isModalLoading" />
                        <div v-else class="add__content">

                            <div class="policy">
                                <div class="policy__form">
                                    <div class="policy__inputs">
                                        <div class="policy__column">
                                            <div class="form__field">
                                                <div class="input input--default input--readonly">
                                                    {{ customerDetails.team.name }}
                                                </div>
                                            </div>

                                            <div class="form__field">
                                                <VSelect v-if="customerMembers.length"
                                                    :class="{ disable: teamId == null }" class="select select--default"
                                                    :options="customerMembers" :reduce="(member) => member.id"
                                                    :getOptionLabel="(member) => parseCustomerName(member)
                                                        " v-model="policy.customerId" />
                                                <div v-else class="input input--default input--readonly">
                                                    {{ parseCustomerName(customerDetails) }}
                                                </div>
                                            </div>

                                            <div class="form__field">
                                                <VSelect
                                                    :class="{ disable: teamId == null, 'select--error': companyHasError }"
                                                    class="select select--default" :options="companies"
                                                    :reduce="(company) => company.id" v-model="companyId" label="name"
                                                    placeholder="Firma" />
                                                <div class="form__error" v-if="companyHasError">
                                                    {{ $t(`addPolicyModal.${"companyErrorMsg"}`) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="policy__column">
                                            <div class="form__field">
                                                <VSelect :class="{ 'select--error': agentHasError }" :options="agents"
                                                    :reduce="(agent) => agent.id" class="select select--default"
                                                    placeholder="Berater" v-model="policy.agentId"
                                                    :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`" />
                                                <div class="form__error" v-if="agentHasError">
                                                    {{ $t(`addPolicyModal.${"agentErrorMsg"}`) }}
                                                </div>
                                            </div>
                                            <div class="form__field">
                                                <div class="mandat">
                                                    <label class="mandat__title" for="mandatCheckbox">Makler
                                                        Mandat</label>
                                                    <div class="checkbox">
                                                        <input :class="{ disable: teamId == null }" type="checkbox"
                                                            id="mandatCheckbox" class="checkbox__checkbox"
                                                            v-model="enableBrokerFirma" />
                                                        <label for="mandatCheckbox" class="checkbox__label"></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form__field">
                                                <div class="mandat" v-if="policy.agentId">
                                                    <label class="mandat__title" for="begleittermin"> {{
                                                        $t(`addSaleCategoryModal.${"secondAgent"}`) }}</label>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="begleittermin"
                                                            class="checkbox__checkbox" v-model="appoiment" />
                                                        <label for="begleittermin" class="checkbox__label"></label>
                                                    </div>
                                                </div>
                                                <div class="mandat disabled-el" v-else>
                                                    <label class="mandat__title" for="begleittermin"> {{
                                                        $t(`addSaleCategoryModal.${"secondAgent"}`) }}</label>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="begleittermin"
                                                            class="checkbox__checkbox" disabled />
                                                        <label for="begleittermin"
                                                            class="checkbox__label disabled-el"></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form__field" v-if="appoiment">
                                                <VSelect :class="{ 'select--error': agent2HasError }"
                                                    :options="filteredAgents" :reduce="(agent) => agent.id"
                                                    class="select select--default" placeholder="Agent"
                                                    v-model="policy.agentId2"
                                                    :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`"
                                                    @input="getAgentData($event)" />
                                                <div class="form__error" v-if="agent2HasError">
                                                    {{ $t(`addPolicyModal.${"agentErrorMsg"}`) }}
                                                </div>
                                            </div>
                                            <div class="form__field" v-if="appoiment">
                                                <VSelect :class="{ 'select--error': saleCategoryHasError }"
                                                    :options="agentSaleCategories" :reduce="(category) => category.id"
                                                    class="select select--default" placeholder="Provisionsteilung"
                                                    v-model="policy.saleCategory" :getOptionLabel="getCategoryLabel" />
                                                <div class="form__error" v-if="saleCategoryHasError">
                                                    {{ $t(`addPolicyModal.${"saleCategoryErrorMsg"}`) }}
                                                </div>
                                            </div>
                                            <div class="form__field">
                                                <VSelect :class="{ disable: teamId == null }" v-if="enableBrokerFirma"
                                                    class="select select--default" :options="brokerCompanies"
                                                    :reduce="(company) => company.id" label="name"
                                                    placeholder="Broker Firma"
                                                    v-model="policy.policyMandate.companyId" />
                                                <div class="select select--default select--readonly" v-else>
                                                    Broker Firma
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <DropFile @input="files = $event" />
                                </div>

                                <div v-if="showServices" class="policy__service-toggler">
                                    <span>Services</span>
                                    <div class="policy__service-adder" :class="{
                                        'policy__service-adder--active': showServicesDropdown,
                                    }" @click="showServicesDropdown = !showServicesDropdown"></div>

                                    <transition name="fade">
                                        <div class="service-dropdown" v-if="showServicesDropdown">
                                            <Loading v-if="servicesLoading" />
                                            <div v-else class="service-dropdown__content">
                                                <div class="service-dropdown__title">
                                                    {{ $t(`addPolicyModal.${"chooseServiceTitle"}`) }}
                                                </div>

                                                <div class="service-dropdown__search">
                                                    <input 
                                                        type="text" 
                                                        class="input input--default input--search"
                                                        placeholder="Search services..."
                                                        v-model="serviceSearchQuery"
                                                    />
                                                </div>

                                                <div class="service-dropdown__body">
                                                    <div v-if="!filteredServices.length"
                                                        class="service-dropdown__no-data">
                                                        No services found
                                                    </div>

                                                    <template v-else>
                                                        <div class="service-dropdown__item"
                                                            v-for="service in filteredServices" :key="service.id">
                                                            <div class="checkbox">
                                                                <input type="checkbox" class="checkbox__checkbox"
                                                                    :checked="services.some((s) => s.id === service.id)
                                                                        " :id="service.id"
                                                                    @input="addOrRemoveServices($event, service)" />

                                                                <label :for="service.id"
                                                                    class="checkbox__label checkbox__label--smaller"></label>
                                                            </div>
                                                            <label :for="service.id"
                                                                class="service-dropdown__item-title">
                                                                {{ service[`long_${language}`] }}
                                                            </label>
                                                        </div>
                                                    </template>
                                                </div>

                                                <div class="service-dropdown__buttons">
                                                    <button type="button"
                                                        class="service-dropdown__button service-dropdown__button--submit"
                                                        @click="applyServices()"></button>
                                                    <button type="button"
                                                        class="service-dropdown__button service-dropdown__button--cancel"
                                                        @click="closeServicesDropdown()"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </transition>

                                    <span v-if="showServicesErr" style="color: var(--text-12);">Please select a
                                        service</span>
                                </div>

                                <div class="services" v-if="services && showServices">
                                    <Service v-for="service in services" :key="service.id" :service="service"
                                        :companyId="companyId" :deleteService="deleteService"
                                        :servicesToDelete="servicesToDelete" :options="policyStatuses" />
                                </div>


                            </div>
                        </div>
                    </transition>
                </form>

            </div>
            <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading">
            </div>

            <div v-else style="width: 100%;">
                <div v-if="teamId == null" class="disabled-el">
                    <button style="right:250px;  width: 220px;" disabled type="button"
                        class="modal__button modal__button--submit button button--default">
                        <span>{{ $t(`addPolicyModal.${"saveButtonOpenPendency"}`) }}</span>
                    </button>

                    <button type="button" disabled class="modal__button modal__button--submit button button--default">
                        <span>{{ $t(`addPolicyModal.${"saveButton"}`) }}</span>
                    </button>
                </div>

                <div v-else>
                    <button style="right:250px;  width: 220px;" type="button"
                        class="modal__button modal__button--submit button button--default"
                        @click="createPolicy(); continueToPendency = true;">
                        <span>{{ $t(`addPolicyModal.${"saveButtonOpenPendency"}`) }}</span>
                    </button>

                    <button type="button" class="modal__button modal__button--submit button button--default"
                        @click="createPolicy()">
                        <span>{{ $t(`addPolicyModal.${"saveButton"}`) }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import statics from "@/statics";
import Loading from "@/partials/Loading";
import Service from "@/components/AddPolicyModal/Service";
import DropFile from "@/components/DropFile";
import {
    parseCustomerName
} from "@/helpers/entityParsers";
import moment from "moment";
import parseFieldErrors from "@/helpers/parseFieldErrors";
export default {
    name: "AddPolicyModal",

    components: {
        Loading,
        Service,
        DropFile,
    },

    data() {
        return {
            teamIdHasError: false,
            teamId: null,

            continueToPendency: false,

            statics,
            KVG: statics.KVG,
            parseCustomerName,
            parseFieldErrors,
            currentPage: 0,
            showServicesDropdown: false,
            showServices: false,
            enableBrokerFirma: false,
            formLoading: false,
            isRequesting: false,
            servicesLoading: false,
            dropdownServices: [],
            serviceSearchQuery: "",
            companyId: 0,
            preServices: [],
            services: [],
            servicesToDelete: [],

            appoiment: false,

            files: [],

            policy: {
                customerId: "",
                companyId: "",
                agentId: null,
                agentId2: null,
                saleCategory: null,
                policyMandate: {
                    companyId: "",
                },
                submissionDate: ""
            },
            companyHasError: false,
            agentHasError: false,
            agent2HasError: false,
            saleCategoryHasError: false,
            specificErrors: [],
            showServicesErr: false,
        };
    },

    watch: {
        async companyId(id) {
            if (id) {
                this.companyHasError = false;
                this.showServices = true;
                this.servicesLoading = true;
                this.services = [];
                this.preServices = [];
                this.policy.companyId = id;

                if (this.formModels.length) {
                    this.$store.commit("setFormModels", []);
                }

                if (this.singleModel) {
                    this.$store.commit("setSingleModel", {
                        ...this.singleModel,
                        id: "",
                        serviceId: "",
                        startDate: "",
                        franchise: "",
                        accident: "",
                        doctorName: "",
                        price: "",
                        interval: "",
                        startDateHasError: false,
                        priceHasError: false,
                    });
                }

                if (this.singletonFormModels.length) {
                    this.$store.commit("setSingletonFormModels", []);
                }

                try {
                    this.dropdownServices = await this.$store.dispatch(
                        "getCompanyServices",
                        id
                    );
                } catch (err) {
                    console.error(err);
                }
                this.servicesLoading = false;
            } else {
                this.companyHasError = true;
                this.showServices = false;
            }
        },

        "policy.agentId"(id) {
            if (id) {
                this.agentHasError = false;
                this.policy.agentId2 = null;
                this.policy.saleCategory = null;
            } else {
                this.agentHasError = true;
            }
        },

        "policy.agentId2"(id) {
            if (id) {
                this.agent2HasError = false;
            } else {
                this.agent2HasError = true;
            }
        },

        "policy.saleCategory"(id) {
            if (id) {
                this.saleCategoryHasError = false;
            } else {
                this.saleCategoryHasError = true;
            }
        },

        customerDetails: {
            async handler() {
                await this.hydrateFromCustomerDetails();
            },
            deep: true,
        },
    },

    computed: {
        ...mapGetters([
            "policyForms",
            "customerDetails",
            "formModels",
            "singleModel",
            "singletonFormModels",
            "servicesToRemove",
            "policyIsConverting",
            "convertingPolicyData",
            "policyModalLoading",
            "customerMembers",
            "language",
            "userForms",
            'user'
        ]),

        isModalLoading() {
            return this.formLoading || this.policyModalLoading;
        },


        agentSaleCategories() {
            return this.user["second_sales_category"];
        },

        filteredAgents() {
            return this.agents.filter(agent => agent.id !== this.policy.agentId);
        },

        filteredServices() {
            if (!this.serviceSearchQuery) {
                return this.dropdownServices;
            }
            const query = this.serviceSearchQuery.toLowerCase();
            return this.dropdownServices.filter(service => {
                const serviceName = service[`long_${this.language}`] || "";
                return serviceName.toLowerCase().includes(query);
            });
        },

        fetchedTeams() {
            return this.userForms.teams;
        },

        agents() {
            return this.policyForms.agents;
        },

        companies() {
            return this.policyForms.companies;
        },

        brokerCompanies() {
            return this.policyForms["broker-companies"];
        },

        policyStatuses() {
            return this.policyForms["policy-statuses"];
        },

        salesCategoryId() {
            return this.policy.agentId ?
                this.agents.find((agent) => agent.id === this.policy.agentId)
                    .sales_category_id :
                null;
        },
    },

    destroyed() {
        this.closeModal();
    },

    async created() {
        this.formLoading = true;

        if (!(this.$checkRolePermission('policy_create') || this.$checkRolePermission('policy_edit'))) {
            this.closeModal();
        } else {
            await this.$store.dispatch("getUserForms");
            await this.hydrateFromCustomerDetails();
        }

        this.formLoading = false;
    },

    methods: {
        getCategoryLabel(category) {
            const name = category?.name;
            const nameDe = category?.name_de;
            const nameEn = category?.name_en;

            if (this.$i18n.locale === 'de') {
                return nameDe || nameEn || name || '—';
            } else {
                return nameEn || nameDe || name || '—';
            }
        },

        async getAgentData(id) {
            const user = await this.$store.dispatch("getUser", id);
            this.$store.commit("setUser", user);
        },

        closeModal() {
            this.$store.commit("setPolicyIsConverting", false);
            this.$store.commit("setConvertingPolicyData", {});
            this.$store.commit("setPolicyModalLoading", false);
            this.continueToPendency = false;
            this.$store.commit("setShowAddPolicyModal", false);
        },

        async hydrateFromCustomerDetails() {
            const customerTeamId = this.customerDetails?.team?.id;
            
            // Always set the customer ID when customer details are available
            if (this.customerDetails?.id) {
                this.policy.customerId = this.customerDetails.id;
            }
            
            // If no team info, return early
            if (!customerTeamId) {
                return;
            }
            
            // If teamId is already set to this team, skip refetch
            if (this.teamId === Number(customerTeamId)) {
                return;
            }

            // Set the team ID from customer details
            this.teamId = Number(customerTeamId);

            const shouldHandleLoading = !this.formLoading;
            if (shouldHandleLoading) {
                this.formLoading = true;
            }

            try {
                await this.fetchPolicyData(this.teamId);
            } finally {
                if (shouldHandleLoading) {
                    this.formLoading = false;
                }
            }
        },

        goBack() {
            this.currentPage--;
            if (this.currentPage < 0) {
                this.closeModal();
                this.$store.commit("setShowAddCustomerServicesModal", true);
            }
        },

        buildPotentialCustomersPayloadFromQuery() {
            const q = this.$route.query || {};

            return {
                search: q.search || "",
                page: Number(q.page) || 1,
                teams: q.teams ? q.teams.split(",").map(Number) : [],
                agents: q.agents ? q.agents.split(",").map(Number) : [],
                branchCategories: q.branchCategories
                    ? q.branchCategories.split(",").map(Number)
                    : [],
                companyTypes: q.companyTypes ? q.companyTypes.split(",").map(Number) : [],
                priorities: q.priorities ? q.priorities.split(",").map(Number) : [],
                startDateFrom: q.startDateFrom || "",
                startDateTo: q.startDateTo || "",
                endDateFrom: q.endDateFrom || "",
                endDateTo: q.endDateTo || "",
                zip_from: q.zip_from || "",
                zip_to: q.zip_to || "",
                birthday: q.birthday || "",
            };
        },

        async refreshPotentialCustomersTable() {
            if (this.$route.name !== "PotentialCustomers") {
                return;
            }

            try {
                const payload = this.buildPotentialCustomersPayloadFromQuery();
                await this.$store.dispatch("searchPotentialCustomers", payload);
            } catch (error) {
                console.error("Potential customers refresh failed:", error.response?.data || error);
            }
        },

        addOrRemoveServices(event, service) {
            const {
                checked
            } = event.target;
            const existingService = this.preServices.findIndex(
                (s) => s.id === service.id
            );
            if (checked) {
                if (existingService === -1) {
                    this.preServices = [...this.preServices, service];
                    this.servicesToDelete.splice(existingService, 1);
                    const serviceToRemoveExists = this.servicesToRemove.some(
                        (s) => s.id === service.id
                    );
                    if (serviceToRemoveExists) {
                        const filteredServices = this.servicesToRemove.filter(
                            (s) => s.id !== service.id
                        );
                        this.$store.commit("setServicesToRemove", filteredServices);
                    }
                }
            } else {
                this.servicesToDelete = [...this.servicesToDelete, service];
                this.preServices.splice(existingService, 1);
            }
        },

        // BUG FIX FUTURE
        // addOrRemoveServices(event, service) {
        //     const { checked } = event.target;
        //     const existingServiceIndex = this.preServices.findIndex((s) => s.id === service.id);
        //     
        //     if (checked) {
        //         // Add service to preServices if not already there
        //         if (existingServiceIndex === -1) {
        //             this.preServices = [...this.preServices, service];
        //         }
        //         
        //         // FIX: Find correct index in servicesToDelete array
        //         const deleteIndex = this.servicesToDelete.findIndex((s) => s.id === service.id);
        //         if (deleteIndex !== -1) {
        //             this.servicesToDelete.splice(deleteIndex, 1);
        //         }
        //         
        //         // Remove from store's servicesToRemove if present
        //         const serviceToRemoveExists = this.servicesToRemove.some((s) => s.id === service.id);
        //         if (serviceToRemoveExists) {
        //             const filteredServices = this.servicesToRemove.filter((s) => s.id !== service.id);
        //             this.$store.commit("setServicesToRemove", filteredServices);
        //         }
        //     } else {
        //         // Add to servicesToDelete if not already marked
        //         const alreadyMarkedForDelete = this.servicesToDelete.some((s) => s.id === service.id);
        //         if (!alreadyMarkedForDelete) {
        //             this.servicesToDelete = [...this.servicesToDelete, service];
        //         }
        //         
        //         // Remove from preServices
        //         if (existingServiceIndex !== -1) {
        //             this.preServices.splice(existingServiceIndex, 1);
        //         }
        //     }
        // },

        applyServices() {
            this.services = [...this.preServices];

            if (this.servicesToRemove.length) {
                this.servicesToRemove.forEach((service) => {
                    if (service.type === "KVG") {
                        this.$store.commit("setSingleModel", {
                            id: "",
                            serviceId: "",
                            startDate: "",
                            franchise: "",
                            accident: "",
                            doctorName: "",
                            price: "",
                            interval: "",
                            startDateHasError: false,
                            priceHasError: false,
                        });
                    } else if (service.type === "multiple") {
                        this.$store.commit("setFormModels", []);
                    } else if (service.type === "singleton") {
                        const modelToDelete = this.singletonFormModels.findIndex(
                            (model) => model.serviceId === service.id
                        );
                        const singletonModels = [...this.singletonFormModels];
                        singletonModels.splice(modelToDelete, 1);
                        this.$store.commit("setSingletonFormModels", singletonModels);
                    }
                });
                this.servicesToDelete = [];
                this.$store.commit("setServicesToRemove", []);
            }

            const kvg = this.services.find((service) => service.id === this.KVG);
            if (kvg) {
                const indexOfKvg = this.services.findIndex(
                    (service) => service.id === this.KVG
                );
                this.services.splice(indexOfKvg, 1);
                this.services = [kvg, ...this.services];
            this.serviceSearchQuery = "";
                this.preServices = [...this.services];
            }

            this.showServicesDropdown = false;
        },

        closeServicesDropdown() {
            this.preServices = [...this.services];
            this.servicesToDelete = [];
            if (this.servicesToRemove.length) {
                this.$store.commit("setServicesToRemove", []);
            }
            this.showServicesDropdown = false;
        },

        deleteService(serviceId) {
            const serviceToDelete = this.services.findIndex(
                (service) => service.id === serviceId
            );
            this.services.splice(serviceToDelete, 1);
            this.preServices.splice(serviceToDelete, 1);
        },

        // BUG FIX FUTURE
        // deleteService(serviceId) {
        //     // Find index separately for each array
        //     const serviceIndex = this.services.findIndex((service) => service.id === serviceId);
        //     const preServiceIndex = this.preServices.findIndex((service) => service.id === serviceId);
        //     
        //     if (serviceIndex !== -1) {
        //         this.services.splice(serviceIndex, 1);
        //     }
        //     if (preServiceIndex !== -1) {
        //         this.preServices.splice(preServiceIndex, 1);
        //     }
        // },
        //
        // ALTERNATIVE: Using filter (safest approach)
        // deleteService(serviceId) {
        //     this.services = this.services.filter(service => service.id !== serviceId);
        //     this.preServices = this.preServices.filter(service => service.id !== serviceId);
        // },

        validatePolicyFields(callback) {
            const {
                agentId,
                companyId,
                agentId2,
                saleCategory
            } = this.policy;

            if (this.services.length == 0) {
                this.showServicesErr = true;
            } else {
                this.showServicesErr = false;
            }

            if (!companyId) {
                this.companyHasError = true;
            }
            if (!agentId) {
                this.agentHasError = true;
            }

            if (this.appoiment) {
                if (!agentId2) {
                    this.agent2HasError = true;
                }

                if (!saleCategory) {
                    this.saleCategoryHasError = true;
                }
            }

            if (this.services.length > 0 && companyId && agentId) {
                callback(true);
            } else {
                callback(false);
            }
        },
  
        validateModelFields(callback) {
            const finalFormModels = this.$store.getters.formModels;
            const finalSingletons = this.$store.getters.singletonFormModels;
            const finalSingleModel = this.$store.getters.singleModel;

            const hasKvg = this.services.some(service => service.id === this.KVG);
            const kvgIsSingleton = finalSingletons.some(m => m.serviceId === this.KVG);

            // 1. FORCE BRANCH SYNCHRONIZATION
            // This ensures VVG models inherit values from KVG if they share a branch_category_id
            const branchDataMap = {};

            // Collect data from any model that has a status (usually the KVG/Singletons)
            [finalSingleModel, ...finalFormModels, ...finalSingletons].forEach(m => {
                if (m && m.policy_status_id && !branchDataMap[m.branch_category_id]) {
                    branchDataMap[m.branch_category_id] = {
                        status: m.policy_status_id,
                        number: m.policy_number,
                        date: m.submit_date
                    };
                }
            });

            // 2. Validate Form Models (VVG / Multiple)
            finalFormModels.forEach((model, index) => {
                // Sync branch values before checking errors
                if (branchDataMap[model.branch_category_id]) {
                    model.policy_status_id = branchDataMap[model.branch_category_id].status;
                    model.policy_number = branchDataMap[model.branch_category_id].number;
                    model.submit_date = branchDataMap[model.branch_category_id].date;
                }

                const hasStartError = !model.startDate || (model.endDate && moment(model.startDate).isAfter(moment(model.endDate)));
                const hasPriceError = !model.price || model.price < 0 || statics.stringRegex.test(model.price) || statics.symbolRegex.test(model.price);
                const hasStatusError = !model.policy_status_id;
                const hasSubmissionDateError = model.policy_status_id === 1 && !model.submit_date;

                this.$store.commit("setSpecificFormModel", { index, key: "startDateHasError", data: hasStartError });
                this.$store.commit("setSpecificFormModel", { index, key: "priceHasError", data: hasPriceError });
                this.$store.commit("setSpecificFormModel", { index, key: "policy_statusHasError", data: hasStatusError });
                this.$store.commit("setSpecificFormModel", { index, key: "submit_dateHasError", data: hasSubmissionDateError });
            });

            // 3. Validate Singletons
            finalSingletons.forEach((model, index) => {
                const hasStartError = !model.startDate || (model.endDate && moment(model.startDate).isAfter(moment(model.endDate)));
                const hasPriceError = (!model.price || model.price < 0 || statics.stringRegex.test(model.price) || statics.symbolRegex.test(model.price)) && model.serviceId != 32;
                const hasStatusError = !model.policy_status_id;
                const hasSubmissionDateError = model.policy_status_id === 1 && !model.submit_date;

                this.$store.commit("setSpecificSingletonFormModel", { index, key: "startDateHasError", data: hasStartError });
                this.$store.commit("setSpecificSingletonFormModel", { index, key: "priceHasError", data: hasPriceError });
                this.$store.commit("setSpecificSingletonFormModel", { index, key: "policy_statusHasError", data: hasStatusError });
                this.$store.commit("setSpecificSingletonFormModel", { index, key: "submit_dateHasError", data: hasSubmissionDateError });
            });

            // 4. Validate KVG singleModel
            if (hasKvg && !kvgIsSingleton) {
                const hasStartError = !finalSingleModel.startDate || (finalSingleModel.endDate && moment(finalSingleModel.startDate).isAfter(moment(finalSingleModel.endDate)));
                const hasPriceError = !finalSingleModel.price || finalSingleModel.price < 0;
                const hasStatusError = !finalSingleModel.policy_status_id;
                const hasSubmissionDateError = finalSingleModel.policy_status_id === 1 && !finalSingleModel.submit_date;

                this.$store.commit("setSpecificSingleModel", { key: "startDateHasError", data: hasStartError });
                this.$store.commit("setSpecificSingleModel", { key: "priceHasError", data: hasPriceError });
                this.$store.commit("setSpecificSingleModel", { key: "policy_statusHasError", data: hasStatusError });
                this.$store.commit("setSpecificSingleModel", { key: "submit_dateHasError", data: hasSubmissionDateError });
            }

            // 5. Final Aggregated Check
            let modelsToCheck = [...this.$store.getters.formModels, ...this.$store.getters.singletonFormModels];
            if (hasKvg && !kvgIsSingleton) modelsToCheck.push(this.$store.getters.singleModel);

            const allFieldsAreValid = modelsToCheck.every((model) => {
                const errors = [];
                if (model.startDateHasError) errors.push("startDate");
                if (model.priceHasError) errors.push("price");
                if (model.policy_statusHasError) errors.push("status");
                if (model.submit_dateHasError) errors.push("submitDate");

                if (errors.length > 0) {
                    return false;
                }
                return true;
            });

            this.isRequesting = !allFieldsAreValid ? false : this.isRequesting;
            callback(allFieldsAreValid);
        },

        async createPolicy() {
            this.isRequesting = true;
            const teamId = this.teamId;

            this.validatePolicyFields(async (policyState) => {
                this.validateModelFields(async (modelsState) => {
                    if (!policyState || !modelsState || !this.services.length) {
                        this.isRequesting = false;
                        return;
                    }

                    const hasKVG = this.services.some(s => s.id === this.KVG);
                    const kvgIsSingleton = this.singletonFormModels.find(s => s.serviceId === this.KVG);

                    const policyServices = [
                        ...this.formModels.map(model => ({
                            service_id: model.serviceId,
                            service_model_id: model.id,
                            start_date: model.startDate,
                            end_date: model.endDate,
                            premium_interval_id: model.interval,
                            franchise: model.franchise,
                            accident: model.accident,
                            premium: Number(model.price),
                            model_category_id: model.economy,
                            sales_category_id: this.salesCategoryId,
                            plate_number: model.plateNumber || "",
                            policy_number: model.policy_number,
                            policy_status_id: model.policy_status_id,
                            submit_date: model.submit_date,
                        })),

                        ...this.singletonFormModels
                            //.filter(s => s.serviceId !== this.KVG)
                            .map(s => ({
                                service_id: s.serviceId,
                                service_model_id: s.id || null,
                                start_date: s.startDate,
                                end_date: s.endDate,
                                premium_interval_id: s.interval,
                                franchise: s.franchise,
                                accident: s.accident,
                                premium: Number(s.price),
                                model_category_id: s.economy,
                                sales_category_id: this.salesCategoryId,
                                plate_number: s.plateNumber || "",
                                policy_number: s.policy_number,
                                policy_status_id: s.policy_status_id,
                                submit_date: s.submit_date,
                            })),

                        // ...(hasKVG ? [{
                        //     service_id: this.singleModel.serviceId,
                        //     service_model_id: this.singleModel.id,
                        //     start_date: this.singleModel.startDate,
                        //     end_date: this.singleModel.endDate,
                        //     premium_interval_id: this.singleModel.interval,
                        //     franchise: this.singleModel.franchise,
                        //     accident: this.singleModel.accident,
                        //     premium: Number(this.singleModel.price),
                        //     model_category_id: this.singleModel.economy,
                        //     sales_category_id: this.salesCategoryId,
                        //     plate_number: this.singleModel.plateNumber || "",
                        //     policy_number: kvgIsSingleton?.policy_number || null,
                        //     policy_status_id: kvgIsSingleton?.policy_status_id || null,
                        //     submit_date: kvgIsSingleton?.submit_date || null,
                        // }] : [])

                        ...(hasKVG && !kvgIsSingleton ? [{
                            service_id: this.singleModel.serviceId,
                            service_model_id: this.singleModel.id,
                            start_date: this.singleModel.startDate,
                            end_date: this.singleModel.endDate,
                            premium_interval_id: this.singleModel.interval,
                            franchise: this.singleModel.franchise,
                            accident: this.singleModel.accident,
                            premium: Number(this.singleModel.price),
                            model_category_id: this.singleModel.economy,
                            sales_category_id: this.salesCategoryId,
                            plate_number: this.singleModel.plateNumber || "",
                            policy_number: this.singleModel.policy_number,
                            policy_status_id: this.singleModel.policy_status_id,
                            submit_date: this.singleModel.submit_date,
                        }] : [])
                    ];

                    try {
                        const response = await this.$store.dispatch("addPolicy", {
                            ...this.policy,
                            policyServices,
                            teamId,
                        });

                        const policyIds = response.data.data || [];

                        this.$store.commit("setToast", {
                            display: true,
                            type: "success",
                            message: "Policy created successfully.",
                        });

                        if (policyIds.length > 0) {
                            if (this.continueToPendency) {
                                this.openAddNewPendency(policyIds[0].id);
                            }

                            if (this.files.length) {
                                this.formLoading = true;
                                for (const p of policyIds) {
                                    await this.$store.dispatch("addPolicyFile", {
                                        policyId: p.id,
                                        files: this.files.map(f => f.file),
                                    });
                                }
                                this.formLoading = false;
                            }
                        }

                        if (this.policyIsConverting) {
                            await this.$store.dispatch("deletePotentialPolicy", this.convertingPolicyData.id);
                        }

                        if (this.$route.name === "PotentialCustomers") {
                            await this.refreshPotentialCustomersTable();
                        } else if (this.customerDetails?.id) {
                            await this.$store.dispatch("getGlobalCustomer", this.customerDetails.id);
                        }
                        this.closeModal();

                    } catch (err) {
                        console.error("Policy Creation Error:", err);
                        this.$store.commit("setToast", {
                            display: true,
                            type: "error",
                            message: err.response?.data?.message || "Policy creation failed.",
                        });
                    } finally {
                        this.isRequesting = false;
                    }
                });
            });
        },

        openAddNewPendency(policy) {
            this.$store.commit("setShowAddActivityModal", false);
            this.$store.commit("setShowAddPendencyModal", true);

            this.$store.commit("setFromPolicyId", policy.id);
            this.$store.commit("setFromPolicyAgentId", policy.agent.id);
        },

        async fetchPolicyData(id) {
            this.$store.commit("setAgents", null);
            await this.$store.dispatch("getPolicyForms", id);
            this.policy.customerId = this.customerDetails.id;

            if (this.policyIsConverting) {
                this.policy.agentId = this.convertingPolicyData.agentId;
                this.policy.policyNumber = this.convertingPolicyData.text;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.modal__panel--service {
    height: 90%;
    top: 2%;
}


.policy__service-adder {
    margin-right: 25px;
}

.disabled-el {
    .mandat {
        .checkbox {
            label {
                border: 1px solid #7F8FA480;
            }
        }
    }

    label {
        color: #7F8FA480 !important;
    }
}

.policy {
    padding-bottom: 30px;
    box-shadow: none;

    &__form {
        display: flex;
        border-bottom: 1px solid var(--border-10);
        padding-bottom: 20px;
    }

    &__inputs {
        flex: 1;
        display: flex;
    }

    &__column {
        margin-right: 10px;
        flex: 1;

        .form__field {
            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .mandat {
        display: flex;
        align-items: center;
        margin: 31px 10px;

        &__title {
            color: var(--text-2);
            font-family: var(--muli-text-semi-bold);
            margin-right: 10px;
        }
    }

    ::v-deep &__service-toggler {
        position: relative;
        margin: 15px 0;
        padding-right: 20px;
        display: inline-flex;
        align-items: center;

        span {
            color: var(--text-2);
            font-size: var(--x-small);
            font-family: var(--muli-text-semi-bold);
        }
    }

    ::v-deep &__service-adder {
        width: 24px;
        height: 24px;
        background: var(--bg-2);
        margin-left: 22px;
        border-radius: var(--radius-3);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:before {
            content: "";
            display: block;
            width: 15px;
            height: 15px;
            background: url("../assets/icons/default/add_icon.svg") no-repeat center;
            background-size: 15px;
            transition: all 0.3s ease;
        }

        &--active:before,
        &:hover:before {
            transform: rotate(180deg);
        }
    }

    ::v-deep .service-dropdown {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 100%;
        min-height: 265px;
        background: var(--bg-1);
        padding: 10px 20px;
        border: 1px solid var(--border-2);
        border-radius: var(--radius-1);
        box-shadow: 0px 3px 30px var(--shadow-4);
        width: 400px;
        transition: all 0.3s ease;

        &__title {
            color: var(--text-5);
            margin-bottom: 10px;
        }

        &__search {
            margin-bottom: 15px;

            .input--search {
                width: 100%;
                height: 35px;
                font-size: var(--x-small);
            }
        }

        &__item {
            display: flex;
            align-items: center;
            font-size: var(--x-small);
            color: var(--text-2);
            padding: 6px 0;
        }

        &__item-title {
            margin-left: 10px;
        }

        &__content {
            position: relative;
        }

        &__body {
            max-height: 176px;
            overflow: auto;
            margin-bottom: 10px;
        }

        &__buttons {
            display: flex;
            justify-content: flex-end;
        }

        &__button {
            width: 44px;
            height: 27px;
            border-radius: var(--radius-1);

            &--submit {
                background-color: var(--bg-2);
                margin-right: 20px;
                background-image: url("../assets/icons/default/tick_icon.svg");
            }

            &--cancel {
                background: var(--bg-12);
                background-image: url("../assets/icons/default/x_icon_white.svg");
            }

            &--submit,
            &--cancel {
                background-repeat: no-repeat;
                background-size: 15px;
                background-position: center;
            }
        }
    }

    .services {
        border-top: 1px solid var(--border-10);
    }

    .service-dropdown__no-data{
        color: var(--text-2);
    }
}
</style>
